import { ExistingAppDescriptionContext, makeSimpleComponentConfiguratorContext } from "./components";
import {
    ScreenDescription,
    InputOutputTables,
    isClassOrArrayScreenDescription,
    userProfileScreenName,
} from "./description";
import { AppDescriptionVisitor, walkAppDescription } from "./components/walk-app-description";
import { defaultUserFeatures } from "../components/SerializedApp";
import { eminenceFlags } from "../Database/eminence";

export function getScreensUsedByApp(
    adc: ExistingAppDescriptionContext,
    withAllTabsAndDefaultScreens: boolean
): readonly [string, ScreenDescription][] {
    const screensUsed = new Map<string, ScreenDescription>();
    class Visitor implements AppDescriptionVisitor {
        public visitScreen(screenName: string, screen: ScreenDescription, tables: InputOutputTables | undefined): void {
            // The `screenName !== userProfileScreenName` clause is just here
            // to make the behavior exactly the same as the old
            // `getScreensUsedInApp`.  Once we switch over to this we can
            // safely remove it.
            if (
                isClassOrArrayScreenDescription(screen) &&
                tables === undefined &&
                screenName !== userProfileScreenName
            ) {
                return;
            }
            screensUsed.set(screenName, screen);
        }
    }
    const ccc = makeSimpleComponentConfiguratorContext(
        adc.appID,
        adc.appDescription,
        adc.builderActions,
        adc.schema,
        defaultUserFeatures,
        eminenceFlags.pro
    );
    walkAppDescription(ccc, new Visitor(), withAllTabsAndDefaultScreens, withAllTabsAndDefaultScreens);
    return Array.from(screensUsed);
}
